import { TypeOfShipment } from '@uturn/portal/types/shipment';
import {
	AlertDialog,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	Button,
	Icon,
} from '@uturn/ui-kit';
import { useTranslation } from 'react-i18next';
import {
	typeOfShipmentDescription,
	typeOfShipmentIcon,
	typeOfShipmentTitle,
} from '../utils';

type Props = {
	open: boolean;
	onSelect: (typeOfShipment: TypeOfShipment) => void;
	onCancel: () => void;
	title?: string;
	description?: string;
};

export const CopyShipmentTypeModal = ({
	open,
	onSelect,
	onCancel,
	title,
	description,
}: Props) => {
	const { t } = useTranslation();

	const options = [TypeOfShipment.SINGLE, TypeOfShipment.GROUP];

	return (
		<AlertDialog
			open={open}
			onOpenChange={(next) => {
				if (!next) {
					onCancel();
				}
			}}
		>
			<AlertDialogContent className="max-w-[25rem] md:max-w-[40rem]">
				<AlertDialogHeader>
					<AlertDialogTitle>
						{title ??
							t('pages.shipment-detail.copy-type.title', 'Copy shipment')}
					</AlertDialogTitle>
					<AlertDialogDescription>
						{description ??
							t(
								'pages.shipment-detail.copy-type.description',
								'Do you want to copy this as a single shipment or as a group of identical shipments?',
							)}
					</AlertDialogDescription>
				</AlertDialogHeader>

				<div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
					{options.map((typeOfShipment) => (
						<Button
							key={typeOfShipment}
							type="button"
							variant="outline"
							className="flex h-auto flex-col items-start gap-1 whitespace-normal p-4 text-left"
							onClick={() => onSelect(typeOfShipment)}
						>
							<span className="flex items-center gap-2 font-medium">
								<Icon icon={typeOfShipmentIcon[typeOfShipment]} />
								{typeOfShipmentTitle(t)[typeOfShipment]}
							</span>
							<span className="text-muted-foreground text-sm font-normal">
								{typeOfShipmentDescription(t)[typeOfShipment]}
							</span>
						</Button>
					))}
				</div>

				<AlertDialogFooter>
					<AlertDialogCancel onClick={onCancel}>
						{t('pages.shipment-detail.copy-type.cancel', 'Cancel')}
					</AlertDialogCancel>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
};
